/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CreateDocumentOpporunityUserRequestFromJSON(json) {
    return CreateDocumentOpporunityUserRequestFromJSONTyped(json, false);
}
export function CreateDocumentOpporunityUserRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        userId: !exists(json, 'user_id') ? undefined : json['user_id']
    };
}
export function CreateDocumentOpporunityUserRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        user_id: value.userId
    };
}
